import React from "react";

const LikeButton = ({ liked, onLike, onDislike ,disabled}) => {
  return (
    <button
      onClick={!disabled && (liked ? onDislike : onLike)}
      className={`click disabled:cursor-not-allowed ${liked ? "active" : ""}`}
      disabled={disabled}
    >
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 26 26"
          fill="none"
          className={"cursor-pointer"}
        >
          <g filter="url(#filter0_b_2936_2004)">
            <rect width="26" height="26" rx="13" fill="black" fillOpacity="0.2" />
            <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="white" />
          </g>
          <path
            d="M21 11.308C21 8.92872 19.0238 7 16.5865 7C15.1068 7 13.8011 7.7129 13 8.80255C12.1993 7.7129 10.8932 7 9.41398 7C6.97618 7 5 8.92872 5 11.308C5 11.645 5.04384 11.9715 5.11898 12.2863C5.73223 16.0023 9.9655 19.9234 13 21C16.0341 19.9234 20.2682 16.0023 20.8801 12.2863C20.9562 11.9715 21 11.645 21 11.308Z"
            fill={`${liked ? "red" : "transparent"}`}
            stroke={liked ? "red" : "white"}
          />
        </svg>
      </span>
    </button>
  );
};

export default LikeButton;
